<script lang="ts" context="module">
  import { z } from 'zod';

  export const BUMarqueeThemeSchema = z.object({
    brandColor: z.string().optional()
  });
</script>

<script lang="ts">
  import { ResponsiveVars } from '@twist/core';
  import { cx } from '@emotion/css';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import Marquee from '$components/Animations/Marquee.svelte';
  import LeftBracket from '$components/Icons/LeftBracket.svelte';
  import RightBracket from '$components/Icons/RightBracket.svelte';

  export let bu: string;

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(8, 12))
    .addFluid('bracket-width', toFluidVarInput(3.5, 3.5))
    .addFluid('bracket-height', toFluidVarInput(16.8, 16.8))
    .toCSS();

  $: isNonBlockBU = bu !== 'block';
</script>

<div class={cx('marquee-container', responsiveVars)}>
  <Marquee gap={12}>
    <div class="marquee-content">
      <p>block</p>
      <p class="bu">
        {#if isNonBlockBU}
          <span class="bracket">
            <LeftBracket />
          </span>
        {/if}

        <span class="bu-name">
          {bu}
        </span>

        {#if isNonBlockBU}
          <span class="bracket">
            <RightBracket />
          </span>
        {/if}
      </p>
    </div>
  </Marquee>
</div>

<style>
  .marquee-container {
    max-width: 100vw;
  }

  .marquee-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  p {
    color: white;
    /* 
    This component is completely hidden with BLOCK-WEB-BRAND-RESKIN enabled, 
    so font-family does not need to be updated 
    */
    font-family: var(--twist-font-family-pilat-extended);
    font-weight: 700;
    font-size: var(--font-size);
    line-height: 100%;
    text-transform: uppercase;
  }

  .bu {
    display: flex;
    align-items: center;
    gap: 4.5px;
  }

  .bu-name {
    color: var(--theme-bu-marquee-brand-color);
  }

  .bracket {
    width: var(--bracket-width);
    height: var(--bracket-height);
  }
</style>
